import styled from 'styled-components';

const accent = '#B845A0';
const accentMuted = 'rgba(201, 77, 170, 0.14)';

export const LegalPageRoot = styled.div`
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f8edfa 0%, #f3e4f6 50%, #f8edfa 100%);
  padding: 24px 16px 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LegalCard = styled.article`
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid ${accentMuted};
  box-shadow:
    0 4px 28px rgba(201, 77, 170, 0.07),
    0 1px 3px rgba(0, 0, 0, 0.05);
  padding: 28px 22px 36px;
  @media (min-width: 640px) {
    padding: 40px 48px 52px;
  }
`;

export const LegalBrandRow = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 28px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${accentMuted};
`;

export const LegalLogo = styled.img`
  width: 84px;
  height: 84px;
  object-fit: contain;
  margin-bottom: 14px;
  @media (min-width: 640px) {
    width: 96px;
    height: 96px;
  }
`;

export const LegalDocTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1a0d14;
  line-height: 1.25;
  @media (min-width: 640px) {
    font-size: 1.875rem;
  }
`;

export const LegalDocMeta = styled.p`
  margin: 10px 0 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #6b5a66;
`;

export const LegalBody = styled.div`
  color: #2d2430;
  font-size: 0.9375rem;
  line-height: 1.72;
  @media (min-width: 640px) {
    font-size: 1rem;
    line-height: 1.7;
  }
`;

export const LegalSectionHeading = styled.h2`
  margin: 26px 0 10px;
  font-size: 1.0625rem;
  font-weight: 600;
  color: #1a0d14;
  line-height: 1.35;
  scroll-margin-top: 16px;
  &:first-of-type {
    margin-top: 0;
  }
`;

export const LegalSubheading = styled.h3`
  margin: 18px 0 8px;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #3d2f3d;
  line-height: 1.4;
`;

export const LegalParagraph = styled.p`
  margin: 0 0 14px;
`;

export const LegalList = styled.ul`
  margin: 0 0 16px;
  padding-left: 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LegalOrderedList = styled.ol`
  margin: 0 0 16px;
  padding-left: 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
  list-style-type: decimal;
`;

export const LegalListItem = styled.li`
  &::marker {
    color: ${accent};
  }
`;

export const LegalNestedList = styled(LegalList)`
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const LegalLink = styled.a`
  color: ${accent};
  font-weight: 500;
  text-decoration: none;
  border-bottom: 1px solid rgba(201, 77, 170, 0.35);
  transition: color 0.15s ease, border-color 0.15s ease;
  &:hover {
    color: #8b2e77;
    border-bottom-color: rgba(201, 77, 170, 0.55);
  }
`;
